import { InjectionToken } from '@angular/core';

import { AppConfig } from './config.app.json.type';
import { ProtectedConfig } from './config.protected.json.type';

export const APP_CONFIG: InjectionToken<AppConfig> = new InjectionToken<AppConfig>('APP_CONFIG');

export const PROTECTED_CONFIG: InjectionToken<ProtectedConfig> = new InjectionToken<AppConfig>('PROTECTED_CONFIG');
